import { check } from "./check.js";
import { cleanText } from "./cleanText.js";
export function parsePersonalNumberCheckDigit(checkDigit, personalNumber) {
    const cleanNumber = cleanText(personalNumber);
    if (cleanNumber === '') {
        if (checkDigit !== '<' && checkDigit !== '0') {
            throw new Error(`invalid check digit ${checkDigit}: must be 0 or <`);
        }
        else {
            return checkDigit;
        }
    }
    check(personalNumber, checkDigit);
    return checkDigit;
}
//# sourceMappingURL=parsePersonalNumberCheckDigit.js.map